import styled from 'styled-components';

import KeywordSearchSelectInput from './components/KeywordSearchSelectInput';
import { Option } from '../../types/common.types';

const SearchSectionContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  position: sticky;
  top: 80px;
  left: 0;
  z-index: 15;

  width: 100%;
  padding: ${props => (props.$isMobile ? '0px 20px 24px' : '0px 40px 24px')};

  background-color: #fff;
`;

const SearchButton = styled.button`
  width: fit-content;
  min-width: 25px;
  padding: 0px;

  background-color: transparent;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(194, 196, 200, 1);
`;

const SEARCH_KEYWORD_LIST = [
  {
    label: '프립명',
    value: 'productTitleLike',
  },
  {
    label: '프립ID',
    value: 'productIds',
  },
  {
    label: '옵션명',
    value: 'itemNameLike',
  },
  {
    label: '크루명',
    value: 'nameLike',
  },
  {
    label: '주문ID',
    value: 'orderIds',
  },
  {
    label: '일정ID',
    value: 'scheduleIds',
  },
  {
    label: '전화번호',
    value: 'phoneLike',
  },
];

interface Props {
  isAbledToSearch: boolean;
  handleUpdateSearchQuery: () => void;
  handleSearchKeyword: (opt: Option) => void;
  handleSearchText: (value: string) => void;
  resetSearchQuery: () => void;
  selectedKeyword: Option;
  searchText: string;
  isMobile: boolean;
}

function SearchSection({
  isAbledToSearch,
  handleUpdateSearchQuery,
  handleSearchKeyword,
  handleSearchText,
  selectedKeyword,
  searchText,
  isMobile,
  resetSearchQuery,
}: Props) {
  return (
    <SearchSectionContainer $isMobile={isMobile}>
      <KeywordSearchSelectInput
        keywordList={SEARCH_KEYWORD_LIST}
        selectedKeywordOpt={selectedKeyword}
        selectKeywordHandler={handleSearchKeyword}
        searchText={searchText}
        inputHandler={handleSearchText}
        inputPlaceHandler="검색어를 입력해주세요."
        isAbledToSearch={isAbledToSearch}
        submitHandler={handleUpdateSearchQuery}
      />

      <SearchButton
        onClick={isAbledToSearch ? handleUpdateSearchQuery : resetSearchQuery}
      >
        {isAbledToSearch ? '검색' : '취소'}
      </SearchButton>
    </SearchSectionContainer>
  );
}

export default SearchSection;
